import { useApiData } from 'lib/api';
import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { EmptyIndicator } from 'components/common';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader
} from 'components/common/box';
import { GroupCoursesAdd, GroupCoursesCourse, GroupPaths } from '.';

const GroupCourses = () => {
  const {
    messages,
    pageState: { group }
  } = useReduxState();

  const { data, loading, updateData } = useApiData({
    url: `/admin/groups/${group.id}/courses`
  });

  const administeredCourses = data?.administeredCourses;
  const courses = data?.courses;

  return (
    <div className="courses">
      <Box
        headerContent={
          <GroupCoursesAdd
            administeredCourses={administeredCourses}
            updateCourses={updateData}
          />
        }
        loading={loading}
        padding={0}
        title={messages.commonCourses}
        titleTooltip={messages.groupsCoursesInfo}
      >
        {courses && courses.length ? (
          <BoxTable>
            <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
              <BoxTableCell>{messages.commonCourse}</BoxTableCell>
              <BoxTableCell>{messages.commonMandatory}</BoxTableCell>
              <BoxTableCell>{messages.courseTargetSchedule}</BoxTableCell>
              <BoxTableCell>{messages.commonProgress}</BoxTableCell>
              <BoxTableCell></BoxTableCell>
            </BoxTableHeader>

            {courses.map((course) => (
              <GroupCoursesCourse
                course={course}
                key={course.id}
                updateCourses={updateData}
              />
            ))}
          </BoxTable>
        ) : (
          <EmptyIndicator icon="book" title={messages.commonNoCourses} />
        )}
      </Box>

      <div className="paths">
        <GroupPaths />
      </div>

      <style jsx>{`
        .paths {
          margin-top: 40px;
        }
      `}</style>
    </div>
  );
};

export default GroupCourses;
